import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { UserRoleProvider } from "@/contexts/UserRoleContext";
import { TournamentProvider } from "@/contexts/TournamentContext";
import { lazy, Suspense } from "react";

// Lazy load route components for better performance
const Index = lazy(() => import("./pages/Index"));
const Auth = lazy(() => import("./pages/Auth"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Tournaments = lazy(() => import("./pages/Tournaments"));
const FundraisingImpact = lazy(() => import("./pages/FundraisingImpact"));
const LeagueImpact = lazy(() => import("./pages/LeagueImpact"));
const Configuration = lazy(() => import("./pages/Configuration"));
const Teams = lazy(() => import("./pages/Teams"));
const Facilities = lazy(() => import("./pages/Facilities"));
const Sponsors = lazy(() => import("./pages/Sponsors"));
const Users = lazy(() => import("./pages/Users"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <UserRoleProvider>
      <TournamentProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Loading...</div>}>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/tournaments" element={<Tournaments />} />
                <Route path="/fundraising-impact" element={<FundraisingImpact />} />
                <Route path="/league-impact" element={<LeagueImpact />} />
                <Route path="/teams" element={<Teams />} />
                <Route path="/facilities" element={<Facilities />} />
                <Route path="/sponsors" element={<Sponsors />} />
                <Route path="/config" element={<Configuration />} />
                <Route path="/users" element={<Users />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        </TooltipProvider>
      </TournamentProvider>
    </UserRoleProvider>
  </QueryClientProvider>
);

export default App;
